import { render, staticRenderFns } from "./ComponentLeft.vue?vue&type=template&id=168af6a0&scoped=true&"
import script from "./ComponentLeft.vue?vue&type=script&lang=js&"
export * from "./ComponentLeft.vue?vue&type=script&lang=js&"
import style0 from "./ComponentLeft.vue?vue&type=style&index=0&id=168af6a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168af6a0",
  null
  
)

export default component.exports